<template>
    <div class="tw-flex tw-justify-around tw-w-full">
      <loading-custom :loading="loading" />
      <div class="tw-flex tw-items-center">
        <label class="switch m-0">
            <input
              type="checkbox" 
              v-model="checked">
            <span class="slider round"></span>
        </label>
        <div>
          <input
              type="number"
              step="0.01"
              :disabled="checked == false"
              class="form-control ml-3"
              placeholder="ระบุราคาขั้นตำ่"
              v-model="transport.more_price_free"
          />
        </div>
      </div>
      <div class="tw-flex tw-items-center">
        <button
            v-show="showBtnSave"
            @click="updateInput(transport)"
            type="button"
            data-type="confirm"
            class="btn btn-sm btn-success js-sweetalert"
            title="Delete"
            :disabled="transport.more_price_free < 0 || transport.price < 0"
        >
            บันทึก
        </button>
      </div>
    </div>
</template>

<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 25px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: -2px;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #00b427;
}

input:focus + .slider {
  box-shadow: 0 0 1px #00b427;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>

<script>
import BootstrapToggle from "vue-bootstrap-toggle";

export default {
    props: {
        shop: {
            required: true,
            type: String
        },
        transport: {
            type: Object
        },
        salepageId: {
            required: true,
            type: Number
        }
    },
    components: { BootstrapToggle },
    data() {
        return {
          transportData: [],
          checked: this.transport?.condition_free_status == 1 ? true
              : this.transport?.condition_free_status == 0 ? false
              : false,
          showBtnSave: false,
          loading: false,
        };
    },
    watch: {
        checked(val) {
            this.toggle();
            this.getData()
        },
        'transport.price'(val) {
          this.showBtnSave = true
        },
        'transport.more_price_free'(val) {
          if (val > 0) {
            this.showBtnSave = true
          }
        }
    },
    methods: {
      async getData() {
            await axios
                .get(`/backend/s/${this.shop}/transport/manage-salepage/${this.salepageId}`)
                .then(res => {
                    this.transportData = res.data.salepageTransport;
                });
        },
        toggle() {
            this.loading = true;
            axios
                .post(`/backend/s/${this.shop}/transport/manage-salepage/${this.transport.id}/update-condition-free-status`, {
                    condition_free_status: this.checked
                })
                .then(res => {
                  this.loading = false;
                  this.updateInput(this.transport)
                  
                })
                .catch(err => {
                })
        },
        updateInput(value) {
          this.loading = true;
            if (this.transport.more_price_free == '') {
              this.transport.more_price_free = 0;
            }
            axios
                .put(`/backend/s/${this.shop}/transport/manage-salepage/${value.id}/update-price`, value)
                .then(res => {
                  this.getData();
                  this.showBtnSave = false;
                  this.loading = false;
                })
                .catch(err => {
                   this.loading = false;
                });
        },
        messageAlert(type, title, text) {
            this.$swal({
                icon: type,
                title: title,
                text: text,
                showConfirmButton: true
            });
        },
    }
};
</script>
